import React from "react";
import { useT } from "@/i18n/LanguageContext";

const LanguageSwitcher = ({ variant = "desktop" }) => {
  const { locale, setLocale, locales, t } = useT();
  return (
    <div
      role="group"
      aria-label={t.lang.switch_aria}
      data-testid={`lang-switcher-${variant}`}
      className="inline-flex items-stretch border border-[#D4AF37]/30"
    >
      {locales.map((l) => {
        const active = l.code === locale;
        return (
          <button
            key={l.code}
            type="button"
            data-testid={`lang-btn-${l.code}`}
            aria-pressed={active}
            onClick={() => setLocale(l.code)}
            className={`font-sans text-[11px] uppercase tracked px-3 py-2 transition-colors duration-200 ${
              active
                ? "bg-[#D4AF37]/15 text-[#D4AF37]"
                : "text-steel hover:text-[#D4AF37]"
            }`}
            style={{ letterSpacing: "0.24em", minWidth: 40, minHeight: 36 }}
          >
            {l.label}
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
